"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M9.86 2S3.98 9.18 3.98 12.17C3.99 15.4 6.78 18 9.96 18c3.18-.01 6.04-2.63 6.03-5.86C15.99 9.05 9.86 2 9.86 2z"];
//# sourceMappingURL=tint.js.map